module.exports = __webpack_public_path__ + "static/img/pls@2x.4c5c332d.png";